import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faFlag } from "@fortawesome/free-solid-svg-icons"

export const Flag = (props) => {
  return <FontAwesomeIcon faIcon={faFlag} {...props} />
}
